<template></template>
<script>
	import {mapState} from 'vuex'

	export default {
		name: 'ReportData',
		data() {
			return {
				'zones': ['work', 'planning', 'break', 'muster', 'restricted']
			}
		},
		computed: {
			...mapState([
				'day',
				'time',
				'schedule',
				'workers',
				'watcher',
				'log',
				'alert'
			]),
			range() { return [1, this.day] },
			total_time: {
				get() { return this.$store.state.report.total_time },
				set(value) { this.$store.commit('setState', ['report.total_time', value]) }
			},
			safety: {
				get() { return this.$store.state.report.safety },
				set(value) { this.$store.commit('setState', ['report.safety', value]) }
			},
			mustering: {
				get() { return this.$store.state.report.safety },
				set(value) { this.$store.commit('setState', ['report.mustering', value]) }
			},
			zone_time: {
				get() { return this.$store.state.report.zone_time },
				set(value) { this.$store.commit('setState', ['report.zone_time', value]) }
			},
			travel_time: {
				get() { return this.$store.state.report.travel_time },
				set(value) { this.$store.commit('setState', ['report.travel_time', value]) }
			},
			first_starts: {
				get() { return this.$store.state.report.first_starts },
				set(value) { this.$store.commit('setState', ['report.first_starts', value]) }
			},
			time_in_work_zone: {
				get() { return this.$store.state.report.time_in_work_zone },
				set(value) { this.$store.commit('setState', ['report.time_in_work_zone', value]) }
			},
			certainty_index: {
				get() { return this.$store.state.report.certainty_index },
				set(value) { this.$store.commit('setState', ['report.certainty_index', value]) }
			},
			project_zone_time: {
				get() { return this.$store.state.report.project_zone_time },
				set(value) { this.$store.commit('setState', ['report.project_zone_time', value]) }
			},
			assets_count() { return Object.keys(this.workers).length },
			apprentice_rates: {
				get() { return this.$store.state.report.apprentice_rates },
				set(value) { this.$store.commit('setState', ['report.apprentice_rates', value]) }
			}

		},
		mounted() {
			setTimeout(() => {
				this.getReportData();
			}, 200)
		},
		watch: {
			day() {
				this.getReportData();
			},
			time: {
				handler() {
					if (this.time > 0 && this.time % 900 == 0) this.getReportData();
				}
			}
		},
		methods: {
			getReportData() {
				this.getTotalTime();
				this.safety = this.$report.safety();
				this.mustering = this.$report.mustering_efficiency();
				this.first_starts = this.$report.first_starts();

				this.getTravelTime();
				this.getZoneTime();
				this.time_in_work_zone = this.zone_time.work;
				this.getCertaintyIndex();
				this.getApprenticeRates();

				this.project_zone_time = {};
				for (let zone_type in this.zone_time) {
					let chunks = this.$finder.chunk(this.zone_time[zone_type], 7);
					for (let week_index in chunks) {
						if (this.project_zone_time[week_index] == undefined) this.project_zone_time[week_index] = {};
						this.project_zone_time[week_index][zone_type] = chunks[week_index].reduce((a, b) => a + b, 0) / chunks[week_index].length ;
					}
				}

				let chunks = this.$finder.chunk(this.travel_time, 7);
				for (let week_index in chunks) {
					if (this.project_zone_time[week_index] == undefined) this.project_zone_time[week_index] = {};
					if (this.day == 1 && this.time == 0) return;
					this.project_zone_time[week_index]['travel'] = chunks[week_index].reduce((a, b) => a + b, 0) / chunks[week_index].length ;
				}

			},
			getTotalTime() {
				let total_time = [];
				for (let worker_id in this.workers) {

					let worker = this.workers[worker_id];

					let routine = this.schedule[worker.type];
					let start_time = this.$config.start_time;
					let end_time = this.$config.end_time;
					for (let time in routine) {
						if (routine[time] == 'start') {
							time = time.split(':');
							start_time = { hour: time[0], minute: time[1]}
						}
						if (routine[time] == 'end') {
							time = time.split(':');
							end_time = { hour: time[0], minute: time[1]}
						}
					}

					// duration of a full day
					let time_range = this.moment().hour(end_time.hour).minute(end_time.minute).second('0').diff(this.moment().hour(start_time.hour).minute(start_time.minute).second('0'))/1000;
					for (let i = this.range[0]; i <= this.range[1]; i++) {
						if (i == this.range[1]) {
							// duration of the current day at the current time
							time_range = Math.min(time_range, this.time);
						}
						if (total_time[i] == undefined) total_time[i - 1] = 0;
						total_time[i - 1] += time_range;
					}
				}
				this.total_time = total_time;
			},

			getZoneTime() {
				let data = {};
				for (let i in this.zones) {
					let zone_type = this.zones[i];
					data[zone_type] = this.$report.zone_time(null, zone_type);
				}

				this.zone_time = data;
			},
			getTravelTime() {
				let data = [];

				for (let i = 0; i < this.day; i++) {
					data[i] = this.$report.travel_time(i+1);
				}

				this.travel_time = data;
			},
			getCertaintyIndex() {

				const avg = array => {
					return this.$number.format(
						this.$number.average(array),
						2
					);
				};

				const sc = avg(this.safety);
				const me = avg(this.mustering);
				const fs = avg(this.first_starts);
				const twz = avg(this.time_in_work_zone);
				const certainty_index = this.$number.format((0.3*sc + 0.1*me + 0.6*twz + 0.3*fs), 2);

				this.certainty_index = {
					sc,
					me,
					fs,
					twz,
					value: certainty_index
				}
			},

			//#region compliance reports
			getApprenticeRates() {
				this.apprentice_rates = {}
				const startDate = this.moment().startOf('isoWeek');
				
				for (let i = -7; i < 21; i++) {
					let date = this.moment(startDate).add(i, 'days').format('M/D/YY');
					this.apprentice_rates[date] = {value: Math.floor(Math.random() * (25 - 12 + 1) + 12)}
				}
			}
			//#endregion

		}
	}
</script>
